export default "__VITE_ASSET__CIHTGYre__"